export const ALLOWED_COUNTRIES = [
    'AU', 'AT', 'BE', 'BG', 'CA', 'HR', 'CY','CZ',
    'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'ID',
    'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'MX', 'NL',
    'NZ', 'PL', 'PT', 'RO','SG', 'SK', 'SI', 'ES',
    'SE', 'GB', 'US',
];

export const getCountryName = (countries, code) => {
    let selectedCountry = countries.find(({value}) => value === code);
    let label = '';
    if (selectedCountry && selectedCountry.label) {
        label = selectedCountry.label;
    }
    return label;
}



/** WEBPACK FOOTER **
 ** ./src/_shared/lib/countries/index.js
 **/